import { SaldoDevedorMunicipioService } from './consulta/saldo-devedor-municipio/shared/service/saldoDevedorMunicipio.service';
import { DatePipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AscasModule } from '@ascas/core';
import { AslibModule } from '@aslib/core';
import { AslibEnviromentModule } from '@aslib/enviroment';
import { AslibLoadingModule } from '@aslib/loading';
import { AslibModalModule } from '@aslib/modal';
import { NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TextMaskModule } from 'angular2-text-mask';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { PaginaInicialComponent } from './pagina-inicial/pagina-inicial.component';
import { ControlMessagesComponent } from './shared/component/control-messages/control-messages.component';
import { FerramentaComponent } from './shared/component/ferramenta/ferramenta.component';
import { CustomDatepickerI18n, I18n } from './shared/datapickerI18n.service';
import { NumberOnlyDirective } from './shared/directive/number-only.directive';
import { ModalManagerHelper } from './shared/helpers/modal-manager-helper';
import { ModalManagerComponent } from './shared/modal-manager/modal-manager.component';
import { NgbDateISOParserFormatter } from './shared/ngb-date-parser-formatter';
import { LimitCharPipe } from './shared/pipe/limitChar.pipe';
import { BaseConfig } from './shared/service/base-config.service';
import { GenericHttpService } from './shared/service/generic-http.service';
import { GenericMessageService } from './shared/service/generic-message.service';
import { SharedService } from './shared/service/shared.service';
import { ValidationService } from './shared/service/ValidationService';
import { DatePickerComponent } from './shared/component/data-picker/data-picker.component';
import { DistribuicaoMensalMunicipioComponent } from './consulta/distribuicao-mensal-aos-municipio/distribuicao-mensal-municipio.component';
import { DistribuicaoMensalMunicipioService } from './consulta/distribuicao-mensal-aos-municipio/shared/service/distribuicaoMensalMunicipio.service';
import { IndiceParticipacaoMunicipioComponent } from './consulta/indice-participacao-municipio/indice-participacao-municipio.component';
import { RegularizacaoDespesaOrcamentoComponent } from './consulta/regularizacao-despesa-orcamentaria/regularizacao-despesa-orcamentaria.compenent';
import { IndiceParticipacaoMunicipioService } from './consulta/indice-participacao-municipio/shared/service/indiceParticipacaoMunicipio';
import { RegularizacaoDespesaOrcamentoService } from './consulta/regularizacao-despesa-orcamentaria/shared/service/regularizacaoDespesaOrcamento.service';
import { SaldoDevedorMunicipioComponent } from './consulta/saldo-devedor-municipio/saldo-devedor-municipio.component';
import { Messages } from './shared/helpers/mensages';
import { ReplaceCaractere } from './shared/pipe/replaceCaractere.pipe';
import { ImportarPlanilhaIpmComponent } from './ipm/importacao-planilha-ipm/importar-planilha-ipm.component';
import { ImportarPlanilhaIpmService } from './ipm/importacao-planilha-ipm/shared/service/importar-planilha-ipm.service';
import { GerarArquivoIpmComponent } from './ipm/geracao-arquivo-ipm/geracao-arquivo-ipm.component';
import { GeracaoArquivoIpmService } from './ipm/geracao-arquivo-ipm/shared/service/geracao_arquivo-ipm.service';
import { TransmitirArquivoIpmComponent } from './ipm/transmissao-arquivo-ipm/transmissao-arquivo-ipm.component';
import { TransmissaoArquivoIpmService } from './ipm/transmissao-arquivo-ipm/shared/service/transmissao-arquivo-ipm.service';
import { ConsultaIpvaComponent } from './ipva/consulta-ipva/consulta-ipva.component';
import { ConciliacaoDistribuicaoMunicipioService } from './ipva/consulta-ipva/shared/service/conciliacao-distribuicao-municipio.service';
import { CadastroMunicipiosAptos } from './royalts/cadastra-municipios-aptos/cadastra-municipios-aptos.component';
import { CadastraValorMensalDistribuir } from './royalts/valor-mensal-distribuir/cadastra-valor-mensal-distribuir.component';
import { CurrencyMaskDirective } from './shared/directive/CurrencyMaskDirective';
import { MonthYearDirective } from './shared/directive/MonthYearDirective';

import { ConsultaMunicipiosAptos } from './royalts/cadastra-municipios-aptos/consulta-municipios-aptos.component';
import { DetalheMunicipioComponent } from './royalts/cadastra-municipios-aptos/detalhe-muncipio/detalhe-municipio.component';

import { CadastrarValorMensalDistribuicaoService } from './royalts/shared/service/cadastra-valor-mensal-distribuir..service';
import { GerarValorMensalDistribuir } from './royalts/cadastra-valor-mensal/gerar-valor-mensal/gerar-valor-mensal-municipio.component';
import { ConsultaValorMensalMunicipio } from './royalts/cadastra-valor-mensal/consulta-valor-mensal/consulta-valor-mensal-municipio.component';

import { SearchDropdownComponent } from './shared/search-dropdown/search-dropdown.component';
import { FormsModule } from '@angular/forms';
import { DetalheValorMensalComponent } from './royalts/cadastra-valor-mensal/detalhe-valor-mensal/detalhe-valor-mensal.component';
import { ConsultaValorMensalDistribuir } from './royalts/valor-mensal-distribuir/consulta-valor-mensal-distribuir.component';
import { MunicipiosAptosService } from './royalts/shared/service/municipios-aptos.service';
import { AprovacaoValorMensalComponent } from './royalts/aprovacao-valor-municipio/aprovacao-valor-mensal.component';
import { DetalheValorMensalDistribuirComponent } from './royalts/valor-mensal-distribuir/detalhe-valor-mensal-distribuir/detalhe-valor-mensal-distribuir.component';


registerLocaleData(localePt, 'pt-BR');
@NgModule({
  declarations: [
    AppComponent,
    NumberOnlyDirective,
    ModalManagerComponent,
    PaginaInicialComponent,
    FerramentaComponent,
    ControlMessagesComponent,
    LimitCharPipe,
    LimitCharPipe,
    SearchDropdownComponent,
    DatePickerComponent,
    DistribuicaoMensalMunicipioComponent,
    IndiceParticipacaoMunicipioComponent,
    RegularizacaoDespesaOrcamentoComponent,
    SaldoDevedorMunicipioComponent,
    ReplaceCaractere,
    ImportarPlanilhaIpmComponent,
    GerarArquivoIpmComponent,
    TransmitirArquivoIpmComponent,
    ConsultaIpvaComponent,
    CadastroMunicipiosAptos,
    CadastraValorMensalDistribuir,
    CurrencyMaskDirective,
    MonthYearDirective,
    ConsultaMunicipiosAptos,
    DetalheMunicipioComponent,
    DetalheValorMensalComponent,
    GerarValorMensalDistribuir,
    ConsultaValorMensalMunicipio,
    ConsultaValorMensalDistribuir,
    AprovacaoValorMensalComponent,
    DetalheValorMensalDistribuirComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    CurrencyMaskModule,
    ReactiveFormsModule,
    TextMaskModule,
    NgbModule.forRoot(),
    AslibEnviromentModule.forRoot(),
    AslibModule.forRoot({
      SiglaProjeto: 'SARF',
      CodProjeto: 'SARF',
      Descricao: 'Sistema de Administração de Recursos Financeiros',
      TempoSessao: 20
    }),
    AslibLoadingModule.forRoot(),
    AslibModalModule.forRoot(),
    AscasModule.forRoot()
  ],
  providers: [
    GenericHttpService,
    GenericMessageService,
    BaseConfig,
    SharedService,
    ModalManagerHelper,
    ValidationService,
    DatePipe,
    DistribuicaoMensalMunicipioService,
    Messages,
    RegularizacaoDespesaOrcamentoService,
    IndiceParticipacaoMunicipioService,
    SaldoDevedorMunicipioService,
    ImportarPlanilhaIpmService,
    GeracaoArquivoIpmService,
    TransmissaoArquivoIpmService,
    ConciliacaoDistribuicaoMunicipioService,
    CadastrarValorMensalDistribuicaoService,
    MunicipiosAptosService,
    [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
    {
      provide: NgbDateParserFormatter,
      useClass: NgbDateISOParserFormatter
    },
    NgbDatepickerConfig,
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent],
  entryComponents: [ModalManagerComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts